<div class='wrapperGoogleSignup'>
  <ng-container *ngIf='!meS.OFFICIAL'>
    <btn *ngIf='type=="signup" || type=="signin"' [text]='type == "signup" ? "Sign up with Google":"Sign in with Google"'
         bcg='white' [spinner]='reqPending' svgLeft='google&24'
         (click)='googleSignup()'></btn>
    <btn *ngIf='type=="logout"' text='Logout from Google' bcg='white' [spinner]='reqPending' svgLeft='google&24'
         (click)='googleLogout()'></btn>
  </ng-container>
</div>